import { Typography, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

interface StatusPageLayoutProps {
  title: string;
  message?: React.ReactNode;
  code?: string;
  children?: React.ReactNode;
}

const StatusPageLayout = ({ title, message, code, children }: StatusPageLayoutProps) => (
  <Wrapper maxWidth="sm">
    <Title>{title}</Title>
    {code && <ErrorCode>{code}</ErrorCode>}
    {message && <Message>{message}</Message>}
    {children}
  </Wrapper>
);

const Wrapper = styled(Container)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "10%",
  paddingBottom: 10,
  textAlign: "center",
}));

const Title = styled(Typography)(() => ({
  fontSize: "30px",
  fontWeight: 500,
  marginBottom: 10,
}));

const ErrorCode = styled(Typography)(() => ({
  fontSize: "166px",
  fontWeight: 700,
  color: "#DADAEA",
  marginBottom: 10,
}));

const Message = styled(Typography)(() => ({
  fontSize: "20px",
  marginBottom: 10,
  whiteSpace: "pre-line",
}));

export default StatusPageLayout;
